"use strict";

require("core-js/modules/es.array.sort.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback"));

var _CompletedContext = require("../CompletedContext");

var _react2 = require("@wwnds/react");

require("./TaskMultiSelect.scss");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // import { Button } from "react-bootstrap"
// import ModalFeedback from '../ModalFeedback'


var TaskMultiSelectSubmit = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskMultiSelectSubmit, _Component);

  var _super = (0, _createSuper2.default)(TaskMultiSelectSubmit);

  function TaskMultiSelectSubmit(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskMultiSelectSubmit);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.selected = [];
    }

    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskMultiSelectSubmit, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var temp;
      var label = e.target.innerText;

      if (this.state.selected.includes(label)) {
        temp = this.state.selected.filter(function (item) {
          return item !== label;
        }).sort(); // e.target.blur()
      } else {
        temp = this.state.selected.concat([label]).sort();
      }

      this.setState({
        selected: temp
      });
      e.selected = temp; // this.props.onClick(e);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      console.log("task mount", this.state); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "inline-block",
          width: "100%",
          textAlign: "center",
          marginBottom: "10px"
        }
      }, /*#__PURE__*/_react.default.createElement("form", null, this.props.data.map(function (dataValue) {
        return /*#__PURE__*/_react.default.createElement(_react2.Button, {
          className: _this3.state.selected.includes(dataValue.value) ? "multi-select-button active" : "multi-select-button",
          style: {
            width: _this3.props.buttonWidth
          },
          value: dataValue.value,
          disabled: _this3.state.completed,
          "aria-pressed": _this3.state.selected.includes(dataValue.value),
          "aria-describedby": dataValue.value + "_choice",
          onClick: _this3.handleClick
        }, dataValue.value);
      }), !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          marginTop: "20px"
        }
      }, /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "bdg-submit-button",
        type: "submit",
        style: {
          float: "right"
        },
        onClick: function onClick(e) {
          e.preventDefault();
          var correctSubmission = true;

          _this3.props.data.forEach(function (item, i) {
            if (!item.correct && _this3.state.selected.indexOf(item.value) !== -1 || item.correct && _this3.state.selected.indexOf(item.value) === -1) {
              correctSubmission = false;
            }
          });

          _this3.setState({
            correct: correctSubmission,
            completed: true
          });
        }
      }, "Submit"))), this.state.completed && this.state.correct && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        feedback: this.props.correctFeedback
      }), this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        incorrect: true,
        feedback: this.props.incorrectFeedback
      }));
    }
  }]);
  return TaskMultiSelectSubmit;
}(_react.Component);

exports.default = TaskMultiSelectSubmit;
TaskMultiSelectSubmit.contextType = _CompletedContext.CompletedContext;